(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
  shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_map.atoms,
  isMovingAtom = _svs$lyckoplatsen$sha.isMovingAtom,
  isUserIdleAtom = _svs$lyckoplatsen$sha.isUserIdleAtom;
const PlayPageContainer = _ref => {
  let children = _ref.children;
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const pinLocation = useAtomValue(pinLocationAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const isUserIdle = useAtomValue(isUserIdleAtom);
  const isMoving = useAtomValue(isMovingAtom);
  const charity = useAtomValue(charityAtom);
  const pinLocationType = useAtomValue(pinLocationTypeAtom);
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const hasMobileKeyboard = svs.lyckoplatsen.hooks.useMobileKeyboardDetect();
  const isIphoneSafari = svs.core.detect.os.iOS() && svs.core.detect.formfactor.mobile() && navigator.userAgent.toLowerCase().indexOf('safari') > -1;
  const classNames = useMemo(() => {
    const arr = ['lp-page-play', 'lp-page-grow'];
    if (pinLocationType) {
      arr.push("pin-location-type-".concat(pinLocationType.toLowerCase()));
    }
    if (shouldShowPin) {
      arr.push('showing-pin');
    }
    if (locationConfirmed) {
      arr.push('has-confirmed-location');
    }
    if (pinLocation.lat) {
      arr.push('has-pin-location');
    }
    if (isMoving) {
      arr.push('map-is-moving');
    }
    if (isUserIdle) {
      arr.push('lp-user-is-idle');
    }
    if (charity) {
      arr.push('charity-selected');
    }
    if (isNativeApp) {
      arr.push('is-native-app');
    }
    if (hasMobileKeyboard) {
      arr.push('has-mobile-keyboard');
    }
    return arr;
  }, [pinLocationType, shouldShowPin, locationConfirmed, pinLocation.lat, isMoving, isUserIdle, charity, isNativeApp, hasMobileKeyboard]);
  useEffect(() => {
    const body = document.body;
    if (isIphoneSafari) {
      classNames.forEach(cls => body.classList.add(cls));
    }
    return () => {
      if (isIphoneSafari) {
        classNames.forEach(cls => body.classList.remove(cls));
      }
    };
  }, [classNames, isIphoneSafari]);
  useEffect(() => {
    svs.lyckoplatsen.utils.ui.hideFooter();
    return svs.lyckoplatsen.utils.ui.showFooter;
  }, []);
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  PlayPageContainer
});

 })(window);